<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<alert-success :class="'d-block shadow-sm'" :form="form" message="Client updated successfully."></alert-success>
			</div>
		</div>

		<div v-if="error" class="error">
			{{ error }}
		</div>

		<div v-if="loading">
			<spinner-component :loading="loading" />
		</div>

		<div v-else>
			<div class="d-flex align-items-center justify-content-between mg-b-25">
				<h3 class="df-title">{{ `Manage Company - ${company.name}` }}</h3>
				<div class="d-flex">
					<!-- <a href="#edit-company" data-toggle="modal" class="btn btn-sm pd-x-15 btn-outline-default mg-l-5 shadow-sm"> <i data-feather="user" class="wd-10 mg-r-5"></i> Edit </a> -->
					<div class="dropdown mg-l-5">
						<button class="btn btn-outline-primary dropdown-toggle" type="button" id="company-actions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<i data-feather="tool" class="wd-10 mg-r-5"></i> Actions
						</button>
						<div class="dropdown-menu" aria-labelledby="company-actions">
							<a class="dropdown-item" target="_blank" :href="`/statements/${company.external_client_id}/generate-pdf`">
								<i data-feather="download" class="wd-15 mr-2"></i>Download Statement
							</a>
							<router-link class="dropdown-item" :to="{ name: 'companies.attach-user', params: { company_name: company.name, id: company.external_client_id } }">
								<i data-feather="user-plus" class="wd-15 mr-2"></i>Attach User
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<nav class="nav nav-line tx-medium" id="company-nav">
						<a href="#company-information" class="nav-link active" data-toggle="tab">Company Information</a>
						<a href="#financial-information" class="nav-link" data-toggle="tab">Financial Information</a>
						<a href="#bank-account-information" class="nav-link" data-toggle="tab">Bank Accounts</a>
						<a href="#associated-users-information" class="nav-link" data-toggle="tab">Associated Users</a>
						<a href="#portfolio-information" class="nav-link" data-toggle="tab">Portfolio</a>
					</nav>
				</div>

				<div class="tab-content wd-100p p-3">
					<company-information-component :company="company" />
					<financial-information :financial-information="company.financial_information" />
					<bank-account-information :bank-accounts="company.bank_account_information" />
					<company-users-component :company="company.external_client_id" />
					<portfolio-information :portfolios="company.portfolio" />

					<div class="row">
						<div class="col-md-12 mg-t-10 mg-sm-t-20">
							<label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-sans mg-b-10"><span class="tx-uppercase">Client Since:</span> {{ company.client_since | placeholder }}</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
select.form-control[size],
select.form-control[multiple] {
	height: 150px;
}

.table-sm th,
.table-sm td {
	padding: 0px 10px;
	line-height: 2;
	border-top: none;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
	data() {
		return {
			loading: true,
			error: null,
			company: null,
			form: new Form({}),
		};
	},
	created() {
		this.fetchData();
	},
	computed: {
		...mapGetters({
			cities: 'cities',
			countries: 'countries',
		}),
	},
	methods: {
		...mapActions({
			getCountries: 'getCountries',
			getCities: 'getCities',
			getCompany: 'getCompany',
		}),
		fetchData() {
			this.getCities();
			this.getCountries();

			this.getCompany(this.$route.params.id)
				.then(
					({
						data: {
							data: { company },
						},
					}) => {
						this.company = company;
					}
				)
				.finally(() => (this.loading = false));
		},
	},
};
</script>